import * as index from '@syncfusion/ej2-treemap';
index.TreeMap.Inject( index.TreeMapTooltip,index.TreeMapLegend,index.TreeMapHighlight,index.TreeMapSelection,index.Print,index.PdfExport,index.ImageExport);
export * from '@syncfusion/ej2-treemap';
